export const HISTOGRAM_AQI = 'HISTOGRAM_AQI';
